// extracted by mini-css-extract-plugin
export default {"bannerContainer":"GuP380r6r6RFMKQdy0oD"};